import type { DeletePrioritySchemeSuccessResponse, DeleteSchemeResult } from '../types';
import { fetchWithStatus } from '../utils';

export const refineDeletePrioritySchemeResponse = (
	obj: unknown,
): DeletePrioritySchemeSuccessResponse | undefined => {
	if (!obj || typeof obj !== 'object') return undefined;

	if (!('status' in obj) || typeof obj.status !== 'number') return undefined;

	if (!('body' in obj) || obj.body !== null) return undefined;

	return {
		status: obj.status,
		body: obj.body,
	};
};

export const deletePrioritySchemeRequest = async (
	schemeId: string,
): Promise<DeleteSchemeResult> => {
	try {
		const URL = `/rest/api/2/priorityscheme/${schemeId}`;
		const response: unknown = await fetchWithStatus(URL, {
			method: 'DELETE',
		});

		const responseData: DeletePrioritySchemeSuccessResponse | undefined =
			refineDeletePrioritySchemeResponse(response);

		if (!responseData) {
			return {
				isSuccess: false,
			};
		}

		return {
			isSuccess: true,
		};
	} catch (error: unknown) {
		// for now all errors, including validation errors will be handled with a generic
		// failure flag.
		return {
			isSuccess: false,
		};
	}
};
